// extracted by mini-css-extract-plugin
module.exports = {"videoSection":"VideoSection_videoSection__jc5FU"};